import { c as _c } from "react/compiler-runtime";
import { useActiveAdministrative } from './useAdministrativeLevels';
export const useActiveSubdistrict = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      level: "subdistrict",
      paramKey: "filter[subdistrict]",
      parents: [{
        paramKey: "filter[district]",
        argName: "district"
      }]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const r = useActiveAdministrative(t0);
  let t1;
  if ($[1] !== r.active || $[2] !== r.activeLabel || $[3] !== r.isLoading || $[4] !== r.items || $[5] !== r.selectedParam || $[6] !== r.setActive) {
    t1 = {
      subdistrictParam: r.selectedParam,
      subdistricts: r.items,
      activeSubdistrict: r.active,
      activeSubdistrictLabel: r.activeLabel,
      isLoading: r.isLoading,
      setActiveSubdistrict: r.setActive
    };
    $[1] = r.active;
    $[2] = r.activeLabel;
    $[3] = r.isLoading;
    $[4] = r.items;
    $[5] = r.selectedParam;
    $[6] = r.setActive;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1 as const;
};